import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import firebaseapp from '../firebaseapp'

import globals from '@/globals'

// Layouts
import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav'

import authRoutes from './authRoutes'
import exercisesRoutes from './exercisesRoutes'
import modulesRoutes from './modulesRoutes'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  {
    path: '/',
    component: LayoutHorizontalSidenav,
    children: [{
      path: '',
      name: 'home',
      component: () => import('@/components/Home'),
      meta: {
        requiresAuth: true
      }
    }
    ]
  }
].concat(authRoutes)
  .concat(exercisesRoutes)
  .concat(modulesRoutes)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  const currentUser = firebaseapp.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  if (requiresAuth && !currentUser) {
    setTimeout(() => next('auth/login'), 10)
    return
  }
  setTimeout(() => next(), 10)
})

export default router
